import { clearAccessibility } from "../misc/accessibility";
import { clearAllowedRoutes } from "../misc/allowedRoutes";
import { logout } from "../misc/currentUser";
import { clearMenu } from "../misc/menuData";
import { updateActivityInDetailModalSlice } from "./activity-view/ActivityInDetailView";
import { updatePhaseInDetailModalSlice } from "./phase-view/PhaseInDetailView";
import { updateTaskListDetailsModalSlice } from "./task-list-view/TaskListDetailModalSlice";

export const closeAllModals = (dispatch: any) => {
  dispatch(updatePhaseInDetailModalSlice({ open: false }));
  dispatch(updateActivityInDetailModalSlice({ open: false }));
  dispatch(updateTaskListDetailsModalSlice({ open: false }));
};

export const resetStore = (dispatch: any) => {
  dispatch(logout());
  dispatch(clearAccessibility());
  dispatch(clearAllowedRoutes());
  dispatch(clearMenu());
};
